import React from 'react';
import Styled from 'styled-components';

const Container = Styled.div`
    width:50px;
    height:50px;
    border-radius:50%;
    background-size:cover;
    background-position:center center;
    background-repeat:no-repeat;
    margin:6px;
    border:1px solid #ddd;

`;

export const UserAvatar = function(props) {

    return (
        <Container
            style={{ backgroundImage: `url('${props.user?.avatar}')` }}
        ></Container>
    );
};
